import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { CommonDashboardComponent } from '../dashboard/common-dashboard/common-dashboard.component';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit{
  @ViewChild("dashboardWrapper", { static: true })
  private readonly dashboardWrapperDiv!: ElementRef<HTMLElement>;
  role;
  isHovered = false;
  
  constructor(private readonly layoutService: LayoutService, private readonly encryptStorage: EncryptionStorageService) {
    
  }
  ngOnInit() {
    this.role = this.encryptStorage.getItem("roleName");
     this.layoutService.isSidebarHovered$.subscribe((hovered) => {
      this.isHovered = hovered;
    });
  }
  get isSidebarOpen(): boolean { return this.layoutService.isSidebarOpen; }
  onActivate(_event: any): void {
    const isDashBoardComponent = _event instanceof CommonDashboardComponent;
    if (!isDashBoardComponent)
      this.dashboardWrapperDiv.nativeElement
        .scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
  }
}
